/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

export const qualityUpdate = {
  category: PropTypes.string,
  leftScore: PropTypes.number,
  rightScore: PropTypes.number,
  usesProgressBars: PropTypes.bool,
};

export default PropTypes.shape({ ...qualityUpdate });